module.exports = __webpack_public_path__ + "static/media/quantium_logo.70e3123f.jpg";